<template>
    <modal :customStyle="customStyle" @closed="close" :allowCancel="false" :contentOverflow=false>
            <div class="add-date">
                <h2 class="add-date--heading" v-text="$t('DELETE_DATE_TITLE')"/>
                <p class="add-date--sub-heading" v-text="$t('DELETE_DATE_TEXT_DESCRIPTION')"></p>
                <p class="add-date--questions" v-text="$t('GIFTING_REMINDER_SELECT_DATE')"></p>
                <div class="date-select">
                    <multiselect
                        class="date-select--event shop__multiselect"
                        v-model="selectedReminder"
                        track-by="name"
                        label="name"
                        :allow-empty="false"
                        placeholder="Select the event"
                        :options="specialDates"
                        :show-labels="false"
                        :close-on-select="true"/>
                </div>
                <p class="input-error" v-if="showDateError">{{showDateError[0]}}</p>
            </div>
            <div class="add-date--btn-container">
                <button
                    slot="actions-prefix"
                    :disabled="isProcessing"
                    @click="close"
                    class="btn btn--secondary-black add-date-btn--add">Cancel</button>
                <button
                    slot="actions-suffix"
                    :disabled="isProcessing"
                    @click="deleteSpecialDate"
                    class="btn btn--green add-date-btn--add">{{$t('GIFTING_REMINDER_REMOVE')}}</button>
            </div>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import Modal from '@/components/structure/Modal.vue';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';

export default {
    name: 'RemoveDateModal',
    props: {
        editData: {
            type: Object,
            require: false,
            default: null,
        },
    },
    components: {
        Modal,
        Multiselect,
    },
    data() {
        return {
            selectedReminder: '',
            errorHandler: new ErrorResponseHandler(),
            isProcessing: false,
        };
    },
    computed: {
        ...mapGetters({
            specialDates: 'specialDates/getSpecialDates',
            specialDatesEnabled: 'account/getSpecialDatesEnabled',
        }),
        date() {
            if (this.editData) return new Date(this.editData.date);
            return new Date();
        },
        showDateError() {
            return this.errorHandler.response.date;
        },
        customStyle() {
            return {
                'max-width': '728px',
                'max-height': '564px',
                'border-radius': '8px',
                'padding': '0px',
            };
        },
    },
    mounted() {
        if (this.editData) {
            this.selectedReminder = this.editData;
        }
    },
    methods: {
        deleteSpecialDate() {
            this.isProcessing = true;
            this.$store.dispatch('specialDates/deleteSpecialDate', parseInt(this.selectedReminder?.id))
                .then(() => {
                    this.$store.dispatch('account/fetchUserData', true);
                    this.isProcessing = false;
                    this.close();
                });
        },
        close() {
            this.$emit('closed');
        },
    },
};
</script>

<style lang="scss" scoped>
.add-date {
    max-width: 600px;
    margin: 0 auto;
    &--heading {
        font-size: 25px;
        font-weight: 400;
        line-height: 30px;
        letter-spacing: 0em;
        text-align: left;
    }

    &--sub-heading {
        font-size: 16px;
        font-weight: 300;
        line-height: 22px;
        letter-spacing: -0.011em;
        text-align: left;
    }

    &--questions {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
        margin-top: 24px;
    }

    &-btn {
        &--add {
            min-width: 282px;
            height: 55px;
            margin: 10px 10px;
        }
    }
    &--input {
        width: 100%;
        border: 1px solid #707070;
        padding: 10px 20px;
        color: #1a1a1a;
        font-weight: 200;
        &::placeholder {
            color: #1a1a1a;
        }
    }
    &--btn-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
}

.date-select {
    display: flex;
    min-width: 327px;
    &--event {
        height: 60px;
        width: 540px;
        left: 0px;
        top: 0px;
        border-radius: 2px;
    }
}
.input-error {
    line-height: 15px;
    display: block;
    color: #b1473c;
    margin-bottom: 1.5rem;
    margin-top: 0.75rem;
    width: 100%;
    font-weight: 200;
    font-size: .75rem;
}

    @media (min-width: 768px){
        .add-date {
            max-width: 540px;
            &-btn {
                &--add {
                    min-width: 260px;
                    height: 55px;
                    margin: 10px 10px;
                }
            }

            &--btn-container {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            }
        }
    }

    @media (min-width: 480px) and (max-width: 767px){
        .add-date {
            max-width: 400px;
            &-btn {
                &--add {
                    min-width: 400px;
                    height: 55px;
                    margin: 10px 10px;
                }
            }

            &--btn-container {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }

    @media (min-width: 360px) and (max-width: 479px){
        .add-date {
            max-width: 327px;
            &-btn {
                &--add {
                    min-width: 327px;
                    height: 55px;
                    margin: 10px 10px;
                }
            }

            &--btn-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        }
    }
</style>
